<script lang="ts">
  import { ExpandedNav } from '@packages/ui'
  import type { TExpandedNavProps } from '@packages/utils/types'

  export let options: TExpandedNavProps
</script>

<ExpandedNav {options} showAssets={false} />
